<template>
  <div class="open-cashier-transfer"></div>
</template>

<script>
/**
 * 独立收银端中转页（菜单 2906，url /plugin/dining/cashier-entry）：
 * 点击菜单后新窗口打开独立收银登录页 /cashier/login，本页随即返回上一页，无页面内容
 */
export default {
  name: 'DiningOpenCashier',
  created() {
    window.open(location.origin + '/cashier/login', '_blank')
    this.$router.back()
  }
}
</script>

<style scoped>
.open-cashier-transfer {
  height: 0;
}
</style>
